import Axios from '../../helpers/axiosRequests';
import dotenv from 'dotenv';
import { mapArrayToObj } from '../../helpers/utils';

dotenv.config();
const initialState = {
  status: '',
  message: '',
  companies: {
    data: {},
    pages: 0,
  },
  sales: {
    data: {},
    count: null,
    pages: 0,
    loading: false,
    error: null,
  },
};

export const admin = {
  namespaced: true,
  state: initialState,
  actions: {
    add: ({ commit }, company) => {
      commit('ADD_COMPANY');
      return Axios.post('/companies', company)
        .then((comp) => {
          commit('ADD_SUCCESS', {
            message: comp.data,
          });
        })
        .catch((err) => {
          commit('ADD_FAILURE', {
            message: err,
          });
          throw err;
        });
    },
    reports: ({ commit, dispatch }, { page, limit, search }) => {
      commit('GET_ALL_COMPANIES');
      let ACTION_URL = `/companies?page=${page}&limit=${limit}`;
      if (search) {
        ACTION_URL = `${ACTION_URL}&search=${search}`;
      }
      Axios.get(ACTION_URL).then(
        (res) => {
          const { count, rows } = res.data;
          const data = mapArrayToObj(rows);
          commit('GET_SUCCESS', {
            data,
            pages: Math.ceil(count / limit),
          });
        },
        (err) => {
          commit('GET_FAILURE', {
            message: err,
          });
          dispatch('alert/error', err, { root: true });
        }
      );
    },
    fetchSales: async (
      { commit },
      { page = 1, limit = 50, search, companyId } = {}
    ) => {
      try {
        let url = `/sales?page=${page}&&limit=${limit}`;
        if (search) url += `&search=${search}`;
        if (companyId) url += `&companyId=${companyId}`;
        const res = await Axios.get(url);
        const { rows, count } = res.data;
        const data = mapArrayToObj(rows);
        commit('SET_SALES_DATA', {
          data,
          pages: Math.ceil(count / limit),
          count,
        });
      } catch (error) {
        // console.log(error);
      }
    },
  },

  mutations: {
    ADD_COMPANY(state) {
      state.status = 'loading';
    },
    ADD_SUCCESS(state, msg) {
      state.status = 'success';
      state.message = msg;
    },
    ADD_FAILURE(state, msg) {
      state.status = 'error';
      state.message = msg;
    },
    GET_ALL_COMPANIES(state) {
      state.status = 'loading';
    },
    GET_SUCCESS(state, companies) {
      state.status = 'success getting companies';
      state.companies = companies;
    },
    GET_FAILURE(state, msg) {
      state.status = 'failure getting companies';
      state.message = msg;
    },
    GET_SALES_DATA(state) {
      state.sales = {
        ...state.sales,
        loading: true,
      };
    },
    SET_SALES_DATA(state, { data, pages, count }) {
      state.sales = {
        ...state.sales,
        loading: false,
        data,
        pages,
        count,
      };
    },
    SET_SALES_ERROR(state, error) {
      state.sales = {
        ...state.sales,
        loading: false,
        error,
      };
    },
  },

  getters: {
    getAllCompanies: (state) => state.companies,
    getAllSales: (state) => state.sales,
  },
};
